import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { voterAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

export type AddLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  farmAddress: Address
  earnedAddresses: Array<Address>
  tokenId?: number
}

export const claimClFarmReward = async ({
  account,
  chainId,
  config,
  voterAddress,
  farmAddress,
  earnedAddresses,
  tokenId = 0,
}: AddLiquidityProps): Promise<TransactionReturnType> => {
  try {
    console.log("🚀 claimClFarmReward params:", {
      account,
      chainId,
      voterAddress,
      farmAddress,
      earnedAddresses,
      tokenId,
    })

    // Create arrays for contract call
    const farmAddresses = [farmAddress]
    const wrappedEarnedAddresses = [earnedAddresses]

    console.log("📦 Preparing contract args:", {
      farmAddresses,
      wrappedEarnedAddresses,
    })

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: voterAbi as Abi,
        account,
        address: voterAddress,
        functionName: "claimRewards",
        args: [farmAddresses, wrappedEarnedAddresses],
        chainId,
      },
    })

    console.log("✅ Contract call result:", result)
    return result
  } catch (error: unknown) {
    console.error("❌ claimClFarmReward error:", error)
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      code: error instanceof Error && "code" in error ? Number((error as { code: string }).code) : 0,
    }
  }
}
